module.exports = __webpack_public_path__ + "img/4-sdg-full@2x.ab36e344.png";